import { ErrorNote } from '@/components/ui'
import { useUserProfile } from '@/features/user/hooks'
import { EmailForwardingCard } from './EmailForwardingCard'
import { PacketHeaderCard } from './PacketHeaderCard'
import { AccessCard } from './AccessCard'
import { ProblemsCard } from './ProblemsCard'

/**
 * Settings — anything captured once in the first-run wizard, which a user sees
 * once and then has no way back to. The packet header lives here for exactly
 * that reason: it prints on every log sheet and was otherwise uncorrectable.
 */
export function SettingsScreen() {
  const { data: user, isLoading, error } = useUserProfile()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">Settings</h1>
        <p className="text-sm text-slate-500">{user?.email}</p>
      </div>

      {error != null && <ErrorNote>Couldn't load settings: {error.message}</ErrorNote>}

      {isLoading ? (
        <p className="text-slate-500" role="status">
          Loading…
        </p>
      ) : user != null ? (
        <>
          <PacketHeaderCard user={user} />
          <EmailForwardingCard user={user} />
          <AccessCard email={user.email} />
          <ProblemsCard email={user.email} />
        </>
      ) : null}
    </div>
  )
}
